const request = require('request');

var hello_controller = () => {
    console.log('Frontend em funcionamento!')
}

var getInformation = () => {
    return new Promise((resolve,reject) => {
        request({
            uri: 'https://www.cloudflare.com/cdn-cgi/trace',
            method: 'GET',
        }, (err, res, body) => {
            if (err) return reject(err);
            resolve({err: err, res: res, body: body});
        });
    });
};

module.exports = {
    hello_controller:hello_controller,
    getInformation:getInformation
}